/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_HoursInputs */

const en_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hours`)
};

const es_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horario`)
};

const de_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnungszeiten`)
};

const zh_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`营业时间`)
};

const ar_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ساعات العمل`)
};

const fr_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horaires`)
};

const vi_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giờ mở cửa`)
};

const sw_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saa za kazi`)
};

const th_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เวลาทำการ`)
};

const bs_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radno vrijeme`)
};

const ja_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`営業時間`)
};

const ko_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`영업시간`)
};

const pt_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horário`)
};

const it_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orari`)
};

const sv_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öppettider`)
};

const nl_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Openingstijden`)
};

const da_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åbningstider`)
};

const nb_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Åpningstider`)
};

const fi_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aukioloajat`)
};

const pl_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Godziny otwarcia`)
};

const ru_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Часы работы`)
};

const tr_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çalışma saatleri`)
};

const hi_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खुलने का समय`)
};

const id_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jam buka`)
};

const ms_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waktu operasi`)
};

const cs_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otevírací doba`)
};

const el_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ωράριο`)
};

const he_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שעות פעילות`)
};

const af_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Openingstye`)
};

const hu_contact_hours = /** @type {(inputs: Contact_HoursInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nyitvatartás`)
};

/**
* | output |
* | --- |
* | "Hours" |
*
* @param {Contact_HoursInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_hours = /** @type {((inputs?: Contact_HoursInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_HoursInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_hours(inputs)
	if (locale === "de") return de_contact_hours(inputs)
	if (locale === "zh") return zh_contact_hours(inputs)
	if (locale === "ar") return ar_contact_hours(inputs)
	if (locale === "fr") return fr_contact_hours(inputs)
	if (locale === "vi") return vi_contact_hours(inputs)
	if (locale === "sw") return sw_contact_hours(inputs)
	if (locale === "th") return th_contact_hours(inputs)
	if (locale === "bs") return bs_contact_hours(inputs)
	if (locale === "ja") return ja_contact_hours(inputs)
	if (locale === "ko") return ko_contact_hours(inputs)
	if (locale === "pt") return pt_contact_hours(inputs)
	if (locale === "it") return it_contact_hours(inputs)
	if (locale === "sv") return sv_contact_hours(inputs)
	if (locale === "nl") return nl_contact_hours(inputs)
	if (locale === "da") return da_contact_hours(inputs)
	if (locale === "nb") return nb_contact_hours(inputs)
	if (locale === "fi") return fi_contact_hours(inputs)
	if (locale === "pl") return pl_contact_hours(inputs)
	if (locale === "ru") return ru_contact_hours(inputs)
	if (locale === "tr") return tr_contact_hours(inputs)
	if (locale === "hi") return hi_contact_hours(inputs)
	if (locale === "id") return id_contact_hours(inputs)
	if (locale === "ms") return ms_contact_hours(inputs)
	if (locale === "cs") return cs_contact_hours(inputs)
	if (locale === "el") return el_contact_hours(inputs)
	if (locale === "he") return he_contact_hours(inputs)
	if (locale === "af") return af_contact_hours(inputs)
	if (locale === "hu") return hu_contact_hours(inputs)
	return en_contact_hours(inputs)
});